import React from 'react';
import './Header.css';

const Header = ({ onReset }) => {
  return (
    <header className="bg-brand-orange w-full flex flex-row justify-center items-center relative z-10 px-5 py-[15px] md:py-3 shadow-[0_4px_20px_rgba(255,106,42,0.3)]">
      <button className="absolute left-5 bg-white/20 border-2 border-white rounded-full w-11 h-11 flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-white/30 hover:rotate-[-180deg] active:rotate-[-180deg] active:scale-95 p-0" onClick={onReset} aria-label="Reset products">
        <svg className="text-white" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
          <path d="M21 3v5h-5"/>
          <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
          <path d="M3 21v-5h5"/>
        </svg>
      </button>
      <div className="flex items-center justify-center">
        <img
          src="/Assets/Media_Markt_logo.png"
          alt="expert - Mit den besten Empfehlungen"
          className="h-[70px] md:h-[55px] sm:h-[45px] w-auto transition-transform duration-300 hover:scale-105"
        />
      </div>
    </header>
  );
};

export default Header;

